import { toSnakeCase } from './stringUtils';

type SnakeCase<S extends string> = S extends `${infer Head}${infer Tail}`
  ? Tail extends Uncapitalize<Tail>
    ? `${Lowercase<Head>}${SnakeCase<Tail>}`
    : `${Lowercase<Head>}_${SnakeCase<Tail>}`
  : S;

type SnakeCasedObject<T> = T extends Date
  ? T
  : T extends Array<infer U>
  ? Array<SnakeCasedObject<U>>
  : T extends object
  ? {
      [K in keyof T as K extends string ? SnakeCase<K> : K]: SnakeCasedObject<
        T[K]
      >;
    }
  : T;

export function keysToSnakeCase<T>(obj: T): SnakeCasedObject<T> {
  const transform = (value: unknown): unknown => {
    if (Array.isArray(value)) {
      return value.map(transform);
    }
    if (value && typeof value === 'object' && !(value instanceof Date)) {
      return Object.fromEntries(
        Object.entries(value as Record<string, unknown>).map(([key, val]) => [
          toSnakeCase(key),
          transform(val),
        ])
      );
    }
    return value;
  };

  return transform(obj) as SnakeCasedObject<T>;
}
